import React         from 'react';
import {NavLink}     from "react-router-dom";
import Hamburger     from './img/HamburgerLine.png';
import {AppConsumer} from './App.context';

class Navi extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			mobileMenuOpen: false,
		};

		this.toggleMenu  = this.toggleMenu.bind(this);
		this.onMenuClick = this.onMenuClick.bind(this);
	}

	onMenuClick() {
		this.setState({
			mobileMenuOpen: false,
		});
	}

	toggleMenu(e) {
		e.preventDefault();

		this.setState({
			mobileMenuOpen: !this.state.mobileMenuOpen,
		});
	}

	render() {
		return <AppConsumer>
			{({isLoggedIn, isMobile, links, onLogoutClick}) => {
				const onMenuLogoutClick = () => {
					this.onMenuClick();
					onLogoutClick();
					window.scrollTo(0, 0)
				}

				return <div className="roxxracing_navi-container">
					<div className="roxxracing_navi">
						<NavLink exact className="roxxracing_navi-link" to="/" activeClassName='-active'>
					<span className="roxxracing_navi-link--text">
						Start
					</span>
						</NavLink>
						<NavLink className="roxxracing_navi-link" to="/aktuelles" activeClassName='-active'>
					<span className="roxxracing_navi-link--text">
						Aktuelles
					</span>
						</NavLink>
						<a className="roxxracing_navi-link"
						   href={links.PROFILE}
						   rel="noopener noreferrer">
					<span className="roxxracing_navi-link--text">
						Live Cam
					</span>
						</a>
						<a className="roxxracing_navi-link"
						   href={links.VIDEOS}
						   rel="noopener noreferrer">
					<span className="roxxracing_navi-link--text">
						Videos
					</span>
						</a>
						<a className="roxxracing_navi-link"
						   href={links.PHOTOS}
						   rel="noopener noreferrer">
					<span className="roxxracing_navi-link--text">
						Fotos
					</span>
						</a>
					</div>

					<div className="roxxracing_mobileheader-hamburger--button" onClick={this.toggleMenu}>
						<img className="roxxracing_mobileheader-hamburger--image" src={Hamburger} alt="Mobile Menu" />
					</div>


					<div id="mobile-menu" className={'roxxracing_navi-mobile' + (this.state.mobileMenuOpen ? ' -is-open' : '')}>
						<div className="roxxracing_navi_mobile--menu-item">
							<NavLink exact className="roxxracing_navi-mobilelink" to="/" activeClassName='-active' onClick={this.onMenuClick}>
							<span className="roxxracing_navi-mobilelink--text">
								Start
							</span>
							</NavLink><br />
						</div>
						{isMobile && <div className="roxxracing_navi_mobile--menu-item">
							<NavLink className="roxxracing_navi-mobilelink" to="/info" activeClassName='-active' onClick={this.onMenuClick}>
							<span className="roxxracing_navi-mobilelink--text">
								Info
							</span>
							</NavLink><br />
						</div>}
						<div className="roxxracing_navi_mobile--menu-item">
							<NavLink className="roxxracing_navi-mobilelink" to="/aktuelles" activeClassName='-active' onClick={this.onMenuClick}>
							<span className="roxxracing_navi-mobilelink--text">
								Aktuelles
							</span>
							</NavLink><br />
						</div>
						<div className="roxxracing_navi_mobile--menu-item">
							<a className="roxxracing_navi-mobilelink"
							   href={links.PROFILE} rel="noopener noreferrer" target="_blank">
							<span className="roxxracing_navi-mobilelink--text">
								Live Cam
							</span>
							</a><br />
						</div>
						<div className="roxxracing_navi_mobile--menu-item">
							<a className="roxxracing_navi-mobilelink" href={links.VIDEOS} rel="noopener noreferrer" target="_blank">
							<span className="roxxracing_navi-link--text">
								Videos
							</span>
							</a><br />
						</div>
						<div className="roxxracing_navi_mobile--menu-item">
							<a className="roxxracing_navi-mobilelink" href={links.PHOTOS} rel="noopener noreferrer" target="_blank">
							<span className="roxxracing_navi-mobilelink--text">
								Fotos
							</span>
							</a>
						</div>
						<div className="roxxracing_navi_mobile--menu-item">
							<a className="roxxracing_navi-mobilelink" onClick={onMenuLogoutClick}>
							<span className="roxxracing_navi-mobilelink--text">
								Abmelden
							</span>
							</a>
						</div>
					</div>

				</div>;
			}}
		</AppConsumer>;
	}
}

export default Navi;





// WEBPACK FOOTER //
// ./src/Navigation.js